export const COUNTDOWN_TIME_IN_SECONDS = 30;
